import ApplicationController from '../application_controller'

class EditController extends ApplicationController {
  connect () {
    this.handleTags()
  }

  handleTags () {
    const tags = document.querySelectorAll('kbd')
    tags.forEach((tag) => {
      tag.addEventListener('click', (e) => {
        const text = e.target.textContent
        document.execCommand('copy')

        const tooltip = window.createTooltips(e.target, {
          title: I18n.t('system_messages.hints.copied_tooltip'),
          html: true,
          trigger: 'focus',
          placement: 'bottom'
        })[0]
        tooltip?.show()
      })
    })
  }
}

export default EditController
